import { Container } from "react-bootstrap";
import NewsCardItem from "component/home/newsVersion/components/news-card";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import MainButton from "component/shared/mainButton/MainButton";

export default function NewsTab({ latestNews }) {
  return (
    <Container
      style={{ backgroundColor: "#EBEBEB", height: "500" }}
      className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
    >
      <div className="row">
        {latestNews.length > 0 ? (
          latestNews.map(
            (
              { id, title, brief, image, publishDate, newsTranslation },
              index,
            ) => (
              <NewsCardItem
                key={index}
                image={image}
                title={title}
                description={brief}
                publicationDate={publishDate}
                translations={newsTranslation}
                id={id}
              />
            ),
          )
        ) : (
          <DataNotFound />
        )}
      </div>
      <div className="row">
        <label>
          <br />
        </label>
        <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
        <div className="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12">
          <MainButton
            link={"./mediaLanding/news"}
            text={"all-news"}
            onClick={() => window.scrollTo(0, 0)}
          />
        </div>
      </div>
    </Container>
  );
}
